<template>
  <div class="w-100p position-relative">
    <div class="error " v-if="errorMsg !== ''">{{ errorMsg }}</div>
    <div class="position-absolute" style="right: 60px; top: 15px; z-index: 1001" v-if="isLoading"><img :alt="$t('loading')" :src="loadingUrl"> {{ $t('loading') }} ...</div>

    <template v-if="isBaseDataLoaded">


      <form action="?">

        <div class="mb-3 text-center poll-buttons">
          <template v-for="pollutant in pollutants">
            <a class="button" :class="{'selected': (selectedPollutant === pollutant.table_nazov)}" @click="selectedPollutant = pollutant.table_nazov" v-html="replacePollutantDesc(pollutant.skratka)"></a>
          </template>
        </div>

        <div class="d-flex justify-content-center">
          <label class="w100 tr fl" for="selectDate">{{ $t('ko.date_and_time') }}:</label>

          <select class="w150 fl" id="selectDate" v-model="selectedDate">
            <option v-for="date in listOfDates" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }}</option>
          </select>

          <div class="fl ml-2">
            <button type="button" :title="$t('ko.prev')" class="button w50 button-icon-only fl" @click="nextIndex()" :disabled="nextDisabled"><i class="icon-navigate_before"></i></button>
            <button type="button" :title="$t('ko.next')" class="button w50 button-icon-only fl" @click="prevIndex()" :disabled="prevDisabled"><i class="icon-navigate_next"></i></button>
            <button type="button" :title="$t('ko.refresh_txt')" @click="loadPollutantBaseData()" class="button w75 ml-2 fl">{{ $t('ko.refresh') }}</button>

            <div class="clearfix"></div>
          </div>

        </div>
        <div class="clearfix"></div>
      </form>


      <div class="position-relative w-100p" style="height: 630px">
        <l-map :zoom="zoom"
               :center="center"
               :options="mapOptions"
               ref="mapKoPollutants"
               class="pollutants-map"
        >
          <l-control-zoom position="bottomleft"  ></l-control-zoom>
          <l-tile-layer
              ref="layerBg"
              :url="url"
              :attribution="attribution"
          />
          <l-tile-layer :url="borderUrl" />

          <l-geo-json
              ref="okresyGeoJsonLayer"
              :geojson="okresyGeoJsonData"
              :options-style="okresyStyleFunction"
              :options="okresyGeoJsonOptions"
              :visible="showOkresy"
          />

          <l-image-overlay
              ref="layerImg"
              :url="imageUrl"
              :bounds="[[49.69, 22.68] , [47.65, 16.72]]"
              :opacity="spatialOpacityC"
              className="crispy_image"
              :z-index="1"
              :visible="showSpatialImage && showSpatialCheckBox"
          />

          <l-geo-json
              ref="geoJsonLayer"
              :geojson="currentGeoJsonData"
              :options="geoJsonOptions"
          />


          <l-control
              :position="'topleft'"
              v-if="showSpatialCheckBox"
              style="margin-top: 0"
          >
            <div class="leaflet-control-layers map-settings-panel leaflet-control p-2 d-flex flex-vertical">
              <div style="white-space: nowrap;" class="d-flex align-items-start">
                <input type="checkbox" class="d-block" id="chSpatial" v-model="showSpatialImage">
                <label for="chSpatial" class="d-block">Mapa koncentrácií z modelu RIO</label>
              </div>
              <div class="text-right mb-2"><a class="external" href="/sk/?page=2659" target="_blank">Viac informácií...</a></div>
              <div style="white-space: nowrap; border-top: 1px solid #ccc;" class="form form-clear d-flex align-items-start">
                <label class="d-block" for="slider-opacity">Priehladnosť:</label>
                <input type="range" id="slider-opacity" v-model="spatialOpacity" class="slider w125 ml-2 d-block" style="padding-top: 2px;" min="10" max="100" step="10">
              </div>
              <div style="white-space: nowrap; border-top: 1px solid #ccc;" class="pt-1 d-flex flex-row align-items-start">
                <input type="checkbox" class="d-block" id="chOkresy" v-model="showOkresy">
                <label for="chOkresy" class="d-block">Okresy</label>
              </div>

            </div>

          </l-control>

          <l-control
              :position="'topright'"
              v-if="showSpatialCheckBox && showSpatialImage && scaleImageUrl !== null"
          >
            <div class="leaflet-control-layers leaflet-bar leaflet-control m-0">
              <div class="text-center"><small><strong>Model RIO</strong></small></div>
              <img :src="scaleImageUrl" width="250" />
            </div>

          </l-control>

          <l-control
              :position="'bottomright'"
              v-if="hoveredId > 0"
              style="margin-top: 0"
          >
            <div class="leaflet-control-layers leaflet-bar map-settings-panel leaflet-control">
              <div class="p-0 m-0">
                <KoChart key="tooltipChart" :selected-pollutant-id="selectedPollutant" :station-id-for-chart="hoveredId" chart-type="tooltip"></KoChart>
              </div>
            </div>

          </l-control>



        </l-map>
      </div>

      <KoPollutantsSub v-on:locateStation="locateStationReceived" :selected-pollutant="selectedPollutant" :selected-station-from-map="selectedStation"></KoPollutantsSub>


    </template>
    <template v-else>
      <div class="text-center pt-3"><img :alt="$t('loading')" :src="loadingUrl"> Načítavam údaje...</div>
    </template>


    <div class="clearfix"></div>
  </div>
</template>

<script>

import Axios from "axios";
import SHMUconf from "../shmu_conf";
import {latLng} from "leaflet";
import shmuMixin from "../mixin";
import {LControl, LControlZoom, LGeoJson, LImageOverlay, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import LControlFullscreen from 'vue2-leaflet-fullscreen';
import 'leaflet/dist/leaflet.css'
import okresyGeoJsonMap from '../assets/static/maps/hranice_okresy5.min.json';
import KoChart from "./KoChart";
import KoPollutantsSub from "@/components/KoPollutantsSub";

export default {
  components: {
    KoChart,
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl,
    LControlFullscreen,
    KoPollutantsSub

  },
  name: 'KoPollutants',
  props: {
  },
  mixins: [
    shmuMixin,
  ],
  data() {
    return {
      errorMsg: '',
      selectedPollutant: 't24001',
      isLoading: false,
      isBaseDataLoaded: false,
      isSpatialLoaded: false,
      baseData: null,
      selectedStation: null,
      spatialData: null,
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      selectedDate: null,
      prevDisabled: false,
      nextDisabled: false,
      showSpatialImage: false,
      showOkresy: true,
      hoveredId: null,
      showChartBox: false,
      spatialOpacity: 100,
      showSpatialCheckBox: true,
      imageUrl: SHMUconf.SITE_BASE_URL + 'img/blank.png',
      scaleImageUrl: null,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      currentGeoJsonData: null,
      emptyGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      okresyGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zoom: 8,
      center: latLng(48.688714, 19.596843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',
      markerIndex: 0,


    }
  },
  watch: {
    isBaseDataLoaded(v) {
      if (v) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
      this.selectedDate = this.listOfDates[0];
    },
    selectedDate() {
      if (this.isBaseDataLoaded) {
        this.loadGeoJsonData();
      }
      this.updateImageUrl();
    },
    selectedPollutant(v) {
      if (this.isBaseDataLoaded) {
        this.loadGeoJsonData();
      }

      let allowed_pollutants = ['t24001', 't39001', 't08017', 't03017'];

      if (allowed_pollutants.includes(v)) {
        this.showSpatialCheckBox = true;
        this.updateImageUrl();
      } else {
        this.showSpatialCheckBox = false;
      }

    },
    showSpatialImage(v) {
      this.updateImageUrl();
      this.$ls.set('ko-map-pollutant-show-spatial', v, 365 * 24 * 60 * 60 * 1000);
    },
    isSpatialLoaded(v) {
      if (v) {
        this.updateImageUrl();
      }
    },
    spatialOpacity(v) {
      this.$ls.set('ko-map-pollutant-spatial-opacity', v, 365 * 24 * 60 * 60 * 1000);
    },
    showOkresy(v) {
      this.$ls.set('ko-map-pollutant-show-okresy', v, 365 * 24 * 60 * 60 * 1000);
    },

  },


  mounted() {
    this.loadPollutantBaseData();
    this.currentGeoJsonData = this.emptyGeoJsonData;
    this.okresyGeoJsonData = okresyGeoJsonMap;

    if (typeof window.selectedPollutant !== 'undefined') {
      this.selectedPollutant = window.selectedPollutant;
    }

    if (this.$ls.get('ko-map-pollutant-show-spatial') === false) {
      this.showSpatialImage = false;
    } else {
      this.showSpatialImage = true;
    }

    if (this.$ls.get('ko-map-pollutant-spatial-opacity')) {
      this.spatialOpacity = this.$ls.get('ko-map-pollutant-spatial-opacity');
    }
    if (this.$ls.get('ko-map-pollutant-show-okresy') === false) {
      this.showOkresy = false;
    }




  },
  computed: {
    pollutants() {
      return this.baseData.pollutants.sort((a,b) => a.order - b.order);
    },
    geoJsonOptions() {
      const data = this.currentGeoJsonData;
      const sv = this.selectedPollutant;
      this.markerIndex = 0;
      return {
        onEachFeature: this.onEachFeatureFunction,
        pointToLayer: this.makeSynopPointToLayer,
      };

    },
    listOfDates() {
      let dates = [];
      let max_date_utc = this.$moment(this.baseData.max_date_utc);
      let min_date_utc = this.$moment(this.baseData.max_date_utc).subtract(48, 'hours');
      for (let current_date = max_date_utc.clone(); current_date >= min_date_utc; current_date = this.$moment(current_date).subtract(1, 'hours')) {
        dates.push(current_date);
      }

      return dates;

    },
    selectedDateIndex() {
      const sDate = this.selectedDate;
      return this.listOfDates.findIndex(item => item === sDate);

    },
    spatialOpacityC() {
      return this.spatialOpacity/100;
    },
    okresyStyleFunction() {
      const self = this;
      return (feature) => {

        let curfillColor = 'rgba(0,0,0,0)';
        return {
          fillColor: curfillColor ,
          weight: 1,
          opacity: 0.75,
          color: 'rgba(0,0,0, 0.75)',
          fillOpacity: 0
        }
      };
    },
    okresyGeoJsonOptions() {
      return {
        onEachFeature: this.onEachFeatureFunctionOkresy
      };
    },
    onEachFeatureFunctionOkresy() {
      return (feature, layer) => {
        layer.bindTooltip('Okres ' + feature.properties.name, { direction:'top', offset: [0, 0], sticky:true });
      }
    },


  },
  methods: {
    initMap() {

      const self = this;

      this.$refs.mapKoPollutants.mapObject.invalidateSize();

      this.$refs.mapKoPollutants.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity =  1});
        } else {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity = 0 });
        }
      });



    },
    loadPollutantBaseData: function() {
      const self = this;

      self.isBaseDataLoaded = false;
      self.isLoading = true;
      self.errorMsg = '';
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getavaiblepollutantsandmaxdate', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.baseData = response.data;
              self.isBaseDataLoaded = true;
              self.loadSpatialInformation();
            } else {
              self.errorMsg = 'Nepodarilo sa načítať údaje';
            }
            self.isLoading = false;

          }).catch((error) => {
        self.isLoading = false;
        self.errorMsg = 'Nepodarilo sa nadviazať spojenie so serverom SHMÚ';
      });

    },
    loadSpatialInformation: function() {
      const self = this;

      self.isSpatialLoaded = false;
      self.isLoading = true;
      self.errorMsg = '';
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getspatialinformation', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.spatialData = response.data;
              self.isSpatialLoaded = true;
            } else {
              self.errorMsg = 'Nepodarilo sa načítať priestorové údaje';
            }
            self.isLoading = false;

          }).catch((error) => {
        self.isLoading = false;
        self.errorMsg = 'Nepodarilo sa nadviazať spojenie so serverom SHMÚ';
      });

    },
    loadGeoJsonData: function() {
      const self = this;


      self.isLoading = true;
      self.errorMsg = '';
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getgeojsonforpollutant?pollutant=' + this.selectedPollutant + '&dt=' + this.$moment(this.selectedDate).unix(), {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {

              let resp = response.data;
              let f = JSON.parse(JSON.stringify(resp.features));
              resp.features = f.sort((a,b) => (a.properties.value - b.properties.value))

              self.currentGeoJsonData = resp;
              self.markerIndex = 0;

              self.isGeoJsonLoaded = true;
            } else {
              self.errorMsg = 'Nepodarilo sa načítať údaje';
              this.currentGeoJsonData = this.emptyGeoJsonData;

            }
            self.isLoading = false;

          }).catch((error) => {
        this.currentGeoJsonData = this.emptyGeoJsonData;
        self.isLoading = false;
        self.errorMsg = 'Nepodarilo sa nadviazať spojenie so serverom SHMÚ';
      });

    },

    makeSynopPointToLayer: function(feature, latlng)  {
      const self = this;

      let fp = feature.properties;
      let val = fp.value;

      let ctnt = '';
      let level = feature.properties.limit_level;
      // if (val === 'PDL') level = 'null';
      if (level === null) level = 'null';
      // ctnt += '<div class="b-name">' + feature.properties.name + '</div>';
      ctnt += '<div class="b-value woko_'+level+'">' + val +'</div>';

      let divIcon = L.divIcon({className: 'point-box', html:ctnt, iconAnchor:[30,0]});

      let point = L.marker(latlng, {icon: divIcon});


      point.bindTooltip(feature.properties.name, { direction:'top', offset: [0, 0], sticky:true });

      self.markerIndex++;
      let indexOffset = self.markerIndex * 100;
      if (feature.properties.value === 'PDL' || feature.properties.value === '*') {
        indexOffset = -self.markerIndex * 100;
      }
      point.setZIndexOffset(indexOffset);

      return point;

    },
    onEachFeatureFunction: function(feature, layer)  {
      const self = this;

      layer.on({
        mouseover: function (v) {
          self.hoveredId = v.target.feature.id;
        },
        mouseout: function (v) {
          let id = v.target.feature.id;
          setTimeout(()=> {
            if (parseInt(self.hoveredId) === parseInt(id)) {
              self.hoveredId = null;
            }
          }, 250);
        },
        click: function (v) {
          // console.log('Feature clicked: ' + v.target.feature.id);
          self.selectedStation = v.target.feature.id;
          window.location.href = '#koTab';
        }
      });


    },
    prevIndex() {
      if (this.selectedDateIndex > 0) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex - 1];
      }
    },
    nextIndex() {
      if (this.selectedDateIndex < this.listOfDates.length - 1) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex + 1];
      }
    },
    updateImageUrl() {
      if (this.isSpatialLoaded && this.showSpatialImage) {


        let d = this.spatialData.find(item => item.pollutant_id === this.selectedPollutant);
        if (d) {
          let file = d.items.find(item => parseInt(item.dt_ts_utc) === this.$moment(this.selectedDate).unix());

          this.scaleImageUrl = d.scale;

          if (file) {
            this.imageUrl = d.base_url + file.fname;
          } else {
            this.imageUrl = SHMUconf.SITE_BASE_URL + 'img/blank.png';
          }

        } else {
          this.imageUrl = SHMUconf.SITE_BASE_URL + 'img/blank.png';
        }

        // this.imageUrl =
      } else {
        this.imageUrl = SHMUconf.SITE_BASE_URL + 'img/blank.png';
      }

    },
    locateStationReceived(station) {
      this.$refs.mapKoPollutants.mapObject.flyTo([station.gps_lat, station.gps_lon],10);
    },
    replacePollutantDesc: function(desc) {
      switch (desc) {
        case 'PM10': return 'PM<sub>10</sub>';
        case 'PM2.5': return 'PM<sub>2.5</sub>';
        case 'NO2': return 'NO<sub>2</sub>';
        case 'NOX': return 'NO<sub>X</sub>';
        case 'O3': return 'O<sub>3</sub>';
        case 'SO2': return 'SO<sub>2</sub>';
        case 'BZN': return 'Benzén';
        default: return desc;
      }
    },

  },



}
</script>


<style lang="scss">
@import "src/assets/shmu";

.pollutants-map {
  width: 100%;
  height: 100%;
}

.point-box {
  display: flex;
  flex-direction: column;
  /* min-width: 90px; */
  .b-name {
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    text-shadow: -1px -1px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000;
    opacity: 0;
  }
  .b-value {
    background-color: #ffffff;
    color: #000;
    border: 1px solid #aaaaaa;
    text-align: center;
    border-radius: 3px;
    min-width: 40px;
    padding: 3px 2px;
    font-weight:bold;
    font-size: 13px;
    display: inline-block;
    line-height: 100%;
  }

}


.leaflet-left .leaflet-control {
  margin: 3px !important;
}

.leaflet-popup-content {
  li {
    &:before {
      top: 8px !important;
    }
  }
}

.leaflet-popup-content-wrapper {
  border-radius: 3px;
}

.time-panel {
  padding: 4px 10px;
  font-size: 14px;
}


.legend-icon-wrapper {
  padding-right: 0.25rem !important;
}

.legend-text {
  padding-top: 2px;
}

.leaflet-control-btn-icon {
  font-size: 18px !important;
  padding-top: 3px;

}


.poll-buttons {
  display: flex;
  justify-content: center;
  a {
    display: block;
    min-width: 60px;
    margin-left: 5px !important;
  }
}

.woko_null {
  background: $c-white !important;
  color: $c-white;
}

.woko_0 {
  background: $c-dark-green !important;
  color: $c-white !important;
}

.woko_1 {
  background: $c-green !important;
  color: $c-white !important;
}

.woko_2 {
  background: $c-yellow !important;
  color: $c-black !important;
  a {
    color: $c-black !important;
    &:hover {
      color: $c-link-hover !important;
    }
  }
}

.woko_3 {
  background: $c-orange !important;
  color: $c-black !important;
  a {
    color: $c-black !important;
    &:hover {
      color: $c-link-hover !important;
    }

  }

}

.woko_4 {
  background: $c-red !important;
  color: $c-white !important;
  a {
    color: $c-white !important;
    &:hover {
      color: $c-gray-lighter !important;
    }

  }

}


.crispy_image {
  -ms-interpolation-mode: nearest-neighbor; /* IE */
  image-rendering: -webkit-optimize-contrast; /* Old Android, Safari, UC Browser */
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: crisp-edges; /* Safari */
  image-rendering: pixelated; /* Chrome & Opera */

}


</style>
